enum Order {
  ASC = 'ASC',
  DESC = 'DESC'
};

export default Order;
